import { FC } from 'react';

import { IconProps } from '../types';

const VeganIcon: FC<IconProps> = ({ size, ...props }) => (
  <svg
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    {...props}
    aria-hidden="true"
  >
    <path
      d="M20.6769 29.0177C20.6709 29.0177 20.6656 29.0177 20.6596 29.0177C20.2755 29.017 19.9644 28.7044 19.9652 28.3203C19.9659 27.9369 20.2777 27.6258 20.6611 27.6258C20.6664 27.6258 20.6716 27.6258 20.6769 27.6258C21.1725 27.6258 21.693 27.5626 22.2224 27.4375C25.5379 26.6557 25.6094 26 27.586 22.5764C29.5626 19.1529 28.7911 14.4783 28.587 9.63389C28.5328 8.35123 28.4778 7.03393 28.4514 5.74524C27.3706 6.18962 26.21 6.60537 24.9981 7.0392C19.5677 8.9854 13.412 11.1899 11.5509 17.247C10.6034 20.3305 11.0057 22.9661 13.6064 25.3566C13.8896 25.6165 13.9077 26.0571 13.6479 26.3395C13.3873 26.6227 12.9474 26.6408 12.665 26.381C12.665 26.381 11.0915 25.1576 10.4355 23.0675C9.7418 20.8577 9.66573 18.6456 10.2208 16.8388C11.1472 13.8238 13.0708 11.4159 16.1009 9.47873C18.6963 7.81949 21.6615 6.75751 24.5296 5.73018C26.0849 5.17283 27.5536 4.64712 28.8461 4.0619C29.0607 3.96474 29.31 3.98281 29.5081 4.1101C29.7062 4.23739 29.8275 4.45581 29.829 4.69155C29.8395 6.2815 29.9096 7.95732 29.9781 9.5774C30.1988 14.8165 30.4074 19.7648 28.8521 23.1579C26.8524 27.5218 26.1834 27.9354 22.5425 28.7933C21.9084 28.9431 21.281 29.0185 20.6777 29.0185L20.6769 29.0177Z"
      fill="#030303"
      stroke="#030303"
    />
    <path
      d="M16.6393 36C16.3101 36 16.0171 35.765 15.9554 35.4299C15.3566 32.1769 15.511 28.2355 16.3771 24.6173C17.3826 20.4198 19.2595 16.8234 21.806 14.2167C22.0742 13.9418 22.5148 13.9365 22.7897 14.2054C23.0646 14.4735 23.0699 14.9141 22.801 15.189C17.7434 20.3671 16.2175 29.1642 17.3231 35.1783C17.3924 35.5564 17.1424 35.9187 16.765 35.9887C16.7221 35.9963 16.6799 36 16.6385 36H16.6393Z"
      fill="#030303"
      stroke="#030303"
    />
  </svg>
);

export default VeganIcon;
